module.exports = __webpack_public_path__ + "img/Lampion_boule_papier.ca19f34.png";